module.exports = __webpack_public_path__ + "img/contact.59f1c641.svg";